<div class="signal-card-container">
  <div class="signal-header-container">
    <img [src]="signalData.brandLogo">
    <div class="brand-name">{{ signalData.brandName }}</div>
    <div class="chip-list-container">
      <app-colored-chip-list [chips]="coloredChipList"></app-colored-chip-list>
    </div>
  </div>
  <div class="divider"></div>
  <div class="signal-title">{{ signalData.title }}</div>
  <div class="signal-impact-container">
    <div class="signal-impact">{{ signalData.impactType === 'increase' ? '↗' : '↘' }}</div>
    <div class="signal-impact">{{ signalData.impact }}</div>
  </div>
  <div class="signal-description">{{ signalData.description + extraText }}</div>
  <div class="polaris-chat-button">
    <img [src]="'svg/copilot-star.svg' | assetVersion ">
    <span class="button-text" (click)="onSendMessage()">Analyze this for me</span>
  </div>
</div>
